import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import ExternalLink from "components/Navigation/ExternalLink";
import * as React from "react";
import externalSystemLinks from "externalSystemLinks";
import {ReefResource} from "client/resources/reefResource";

export function linkToInstance(instance: HostedInstanceResource, reefResource: ReefResource) {
    return <ExternalLink href={externalSystemLinks.instance.homePage(instance, reefResource)}>{externalSystemLinks.instance.domain(instance, reefResource)}</ExternalLink>;
}
